export enum InvokeSokets {
  UNSUBSCRIBE_RESIDENT_VITALS = "UnsubscribeFromResidentVitals",
  SUBSCRIBE_RESIDENT_VITALS = "SubscribeToResidentVitals",
  UPDATE_NODES_SUBSCRIPTION = "UpdateNodesSubscription",
}

export enum SName {
  ALERT = "receiveAlert",
  DEVICE_STATE = "receiveDeviceState",
  DEVICE_ADDED = "receiveDeviceAdded",
  DEVICE_DELETED = "receiveDeviceDeleted",
  RESIDENT_DEVICE_ASSIGNED = "receiveResidentDeviceAssigned",
  RESIDENT_DEVICE_DELETED = "receiveResidentDeviceDeleted",
  DEVICE_UPDATED = "receiveDeviceUpdated",

  RESIDENT_ACTIVE_STATUS_CHANGED = "receiveResidentActiveStatusChanged",
  RESIDENT_ADDED = "receiveResidentAdded",
  RESIDENT_BED_STATUS_CHANGED = "receiveResidentBedStatusChanged",
  RESIDENT_DELETED = "receiveResidentDeleted",

  RESIDENT_UPDATED = "receiveResidentUpdated",
  RESIDENT_WITH_DEVICE_WAS_MOVED = "receiveResidentWithDeviceWasMoved",

  ROOM_TEMP_CHANGED = "receiveRoomTempChanged",

  OGR_Notification_SETTING_UPDATED = "receiveNodeNotificationSettingsUpdated",

  ORGANIZATION_ALIVE = "receiveOrganizationServicReady",
  RESIDENTS_ALIVE = "receiveResidentServiceReady",

  ACTIVITY = "receiveActivity",
  USER_UPDATE_NOTIFICATION = "receiveUserUpdateNotification",
  RESIDENT_NODE_PRESENCE_CHANGED_BATCH = "receiveResidentNodePresenceChangedBatch",

  WATCH_ADDED = "receiveWatchAdded",
  WATCH_UPDATED = "receiveWatchUpdated",
  WATCH_DELETED = "receiveWatchDeleted",
  WATCH_MOVED = "receiveWatchMoved",
  WATCH_ALERT = "receiveWatchAlert",
  WATCH_ALERT_HANDLED = "receiveWatchAlertHandled",
  WATCH_STATUS = "receiveWatchStatus",

  // NODE_USER_NEARBY_CONFIG_UPDATED = 'receiveUserNearbyRoomBedConfigUpdated',
  // USER_DEVICE_CONFIG_UPDATED = 'receiveUserConfigurationsUpdated',
}
